import permissions from '@/util/permissions.js';
export default {
  install(Vue) {
    Vue.prototype.$permissions = () => {
      return permissions();
    }
  }
}